/* eslint-disable react/require-default-props */
import React from 'react';
import { Tag } from '@ui/atoms/Tag/Tag';
import { translate } from '@utils/i18n';
import { Checkbox } from '../../inputs/Checkbox';
import { Accordion } from '../../Accordion/Accordion';
import { Table } from '../Table';
/**
 * TableAccordionGroups
 *
 * Renders the accordion grouped presentation (decision 13, 14).
 * Used only when `isGrouped && groupedPresentation === 'accordion'`.
 */
export function TableAccordionGroups({ tableId, paginatedGroups, columns, size, hover, selectable, selectedItems, onSelectionChange, getItemId, sortable, sortableColumns, onSort, sortBy, sortDirection, onRowClick, expandableRowRenderer, expandedRows, activeItemId, allPageSelected, somePageSelected, handleAccordionSelectAll, handleAccordionGroupSelect, effectiveSelectedItems, onFirstSelectedRowRef }) {
    const firstSelectedGroupIdx = onFirstSelectedRowRef
        ? paginatedGroups.findIndex((group) => group.data.some((row) => effectiveSelectedItems.includes(getItemId(row))))
        : -1;
    return (React.createElement(React.Fragment, null,
        selectable && (React.createElement("div", { className: "qmb-ui-table__accordion-select-all" },
            React.createElement(Checkbox, { id: `${tableId}-accordion-select-all`, checked: allPageSelected, indeterminate: somePageSelected, onChange: handleAccordionSelectAll, label: "All", "aria-label": "Select all rows" }))),
        React.createElement("div", { className: "qmb-ui-table__accordion-groups" }, paginatedGroups.map((dataGroup, groupIdx) => {
            var _a;
            const groupItemIds = dataGroup.data.map(getItemId);
            const allGroupSelected = groupItemIds.length > 0 && groupItemIds.every((id) => effectiveSelectedItems.includes(id));
            return (React.createElement(Accordion, { key: `accordion-group-${(_a = dataGroup.id) !== null && _a !== void 0 ? _a : groupIdx}`, variant: "section", defaultExpanded: true, selectable: selectable, checkboxProps: selectable
                    ? {
                        id: `${tableId}-accordion-group-select-${groupIdx}`,
                        checked: allGroupSelected,
                        onChange: (checked) => {
                            handleAccordionGroupSelect(groupItemIds, checked);
                        }
                    }
                    : undefined, title: React.createElement("span", { className: "qmb-ui-table__accordion-group-title" },
                    dataGroup.title,
                    React.createElement(Tag, { label: (() => {
                            const translated = translate('group_count', {
                                namespace: 'ui.table',
                                count: dataGroup.data.length
                            });
                            if (translated === 'group_count' || translated === 'ui.table.group_count') {
                                return `Count: ${dataGroup.data.length}`;
                            }
                            return translated;
                        })(), variant: "gray", colorStyle: "pastry", readOnly: true })), className: "qmb-ui-table__accordion-group" },
                React.createElement(Table, { tableId: `${tableId}-accordion-inner-${groupIdx}`, data: dataGroup.data, columns: columns, variant: "detail", size: size, hover: hover, selectable: selectable, showHeaderSelectAll: false, selectedItems: effectiveSelectedItems, onSelectionChange: onSelectionChange, onSelectAll: (checked) => {
                        handleAccordionGroupSelect(groupItemIds, checked);
                    }, getItemId: getItemId, sortable: sortable, sortableColumns: sortableColumns, onSort: onSort, sortBy: sortBy, sortDirection: sortDirection, onRowClick: onRowClick, expandableRowRenderer: expandableRowRenderer, expandedRows: expandedRows, activeItemId: activeItemId, onFirstSelectedRowRef: groupIdx === firstSelectedGroupIdx ? onFirstSelectedRowRef : undefined })));
        }))));
}
